import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

class LookupListTemplate extends React.Component {
	render() {
		const { viewStore, t } = this.props;
		const { listStore, tableData, loading, queryUtility, allList } = viewStore;
		if (loading)
			return <Loader />;
		if (!viewStore.selectedLookup) {
			const { tableData, queryUtility, onRowClick } = this.props;
			return (
				<React.Fragment>
					<div className="layout__main__subheader">
						<h2 className="layout__main__subheader__title">{t('MAINMENU.ADMINISTRATION.LOOKUPS')}</h2>
					</div>
					<BaasicTable
						{...{ queryUtility, tableData, allList, onRowClick, viewStore }}
						data={viewStore.listStore.data.slice()}
					/>
				</React.Fragment>
			);
		} else {
			let itemName = t(viewStore.selectedLookup.parameters.itemName);
			return (
				<React.Fragment>
					<div className="layout__main__subheader">
						<h2 className="layout__main__subheader__title">
							{t('MAINMENU.ADMINISTRATION.LOOKUPSITEM', { itemName: _.startCase(itemName) })}
						</h2>
					</div>
					<BaasicTable {...{ queryUtility, tableData }} data={listStore.data.slice()} actions={viewStore} />
				</React.Fragment>
			);
		}
	}
}

export default defaultTemplate(LookupListTemplate);
